
    const data = {"name":"src/core/icons/credit-card-outline","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M20 8H4V6h16m0 12H4v-6h16m0-8H4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            